const state = {
    userdata:sessionStorage.getItem("userdata")?JSON.parse(sessionStorage.getItem("userdata")):'',
    loading:false,
    tag:[],
	tagstatus:true,
    toggleflag:false,
	statechange:false
}
export default state